import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";
import { Clock, X } from "lucide-react";

interface Upcoming { ride_id: string; start_time: string; }

export function UpcomingRideBanner() {
  const { user } = useAuth();
  const [upcoming, setUpcoming] = useState<Upcoming | null>(null);
  const [dismissed, setDismissed] = useState<string | null>(null);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    const check = async () => {
      const now = new Date();
      const soon = new Date(now.getTime() + 30 * 60_000);
      const { data } = await supabase
        .from("ride_participants")
        .select("ride_id, rides!inner(id, start_time, status)")
        .eq("user_id", user.id)
        .eq("rides.status", "active")
        .gte("rides.start_time", now.toISOString())
        .lte("rides.start_time", soon.toISOString())
        .order("ride_id", { ascending: true })
        .limit(1);
      if (cancelled) return;
      const row: any = data?.[0];
      if (row?.rides) setUpcoming({ ride_id: row.rides.id, start_time: row.rides.start_time });
      else setUpcoming(null);
    };
    check();
    const iv = setInterval(check, 60_000);
    return () => { cancelled = true; clearInterval(iv); };
  }, [user?.id]);

  if (!upcoming || dismissed === upcoming.ride_id) return null;

  const mins = Math.max(0, Math.round((new Date(upcoming.start_time).getTime() - Date.now()) / 60000));

  return (
    <div className="fixed inset-x-0 top-0 z-[60] pt-[env(safe-area-inset-top)]">
      <div className="flex items-center gap-3 bg-[#F5C518] px-4 py-2.5 text-black shadow-lg">
        <Clock className="h-5 w-5 shrink-0" strokeWidth={2.4} />
        <Link
          to="/ride/$rideId"
          params={{ rideId: upcoming.ride_id }}
          className="flex-1 font-display text-sm font-bold uppercase tracking-wide"
        >
          Tu salida empieza en {mins} min
        </Link>
        <button
          onClick={() => setDismissed(upcoming.ride_id)}
          aria-label="Cerrar"
          className="rounded-full p-1 hover:bg-black/10"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
